import db from "@/db";

const state = {
  userInfo: [],
  subjects: [],
  isEditing: false,
  isAdding: false,
  isCreating: false, //If user is creating a group
  isFaculty: false,
  isCourse: false,
  isGroup: false,
  isShowingSubjects: false,
  isShowingGroupTypes: false, //If user is adding, or editing courses
  groupType: {
    Course: 0,
    Faculty: 1,
    Group: 2,
  },
  updateAllGroups: false,
};

const mutations = {
  setIsAdding(state, isAdding) {
    state.isAdding = isAdding;
  },
  setIsEditing(state, isEditing) {
    state.isEditing = isEditing;
  },
  setIsCreating(state, isCreating) {
    state.isCreating = isCreating;
  },
  setIsCourse(state, isCourse) {
    state.isCourse = isCourse;
  },
  setIsFaculty(state, isFaculty) {
    state.isFaculty = isFaculty;
  },
  setIsGroup(state, isGroup) {
    state.isGroup = isGroup;
  },
  setIsShowingSubjects(state, isShowingSubjects) {
    state.isShowingSubjects = isShowingSubjects;
  },
  setIsShowingGroupTypes(state, isShowingGroupTypes) {
    state.isShowingGroupTypes = isShowingGroupTypes;
  },
  setUpdateAllGroups(state, isUpdating) {
    state.updateAllGroups = isUpdating;
  },
};

const actions = {
  async fetchCourses(_, info) {
    var courses = [];
    db.collection("courses")
      .where("school_id", "==", info.school_id)
      .where("subject", "==", info.subject)
      .orderBy("name")
      .get()
      .then((snapshot) => {
        snapshot.forEach((doc) => {
          var course = doc.data();
          course.id = doc.id;
          courses.push(course);
        });
      });
    return await courses;
  },

  async fetchFaculties(_, school_id) {
    var faculties = [];
    db.collection("faculties")
      .where("school_id", "==", school_id)
      .orderBy("name")
      .get()
      .then((snapshot) => {
        snapshot.forEach((doc) => {
          var faculty = doc.data();
          faculty.id = doc.id;
          faculties.push(faculty);
        });
      });
    return await faculties;
  },

  async fetchGroups(_, info) {
    var groups = [];
    db.collection("groups")
      .where("school_id", "==", info.school_id)
      .where("type", "==", info.type)
      .orderBy("name")
      .get()
      .then((snapshot) => {
        snapshot.forEach((doc) => {
          var group = doc.data();
          group.id = doc.id;
          groups.push(group);
        });
      });
    return await groups;
  },

  async fetchSubjects(_, school_id) {
    var subjects = [];
    db.collection("subjects")
      .where("school_id", "==", school_id)
      .orderBy("name")
      .get()
      .then((snapshot) => {
        snapshot.forEach((doc) => {
          subjects.push(doc.data());
        });
      });
    return await subjects;
  },

  async fetchGroupsForSubject(_, data) {
    var groups = [];
    db.collection("groups")
      .where("school_id", "==", data.school_id)
      .where("subject", "==", data.subject)
      .orderBy("name")
      .get()
      .then((snapshot) => {
        snapshot.forEach((doc) => {
          groups.push(doc.data());
        });
      });
    return await groups;
  },

  async setGroupNotificationInfo({ dispatch }, info) {
    let timeSincePost = await dispatch(
      "getTimeSincePost",
      info.notification.created_at
    );
    let firstName = null;
    if (info.notification.username) {
      firstName = info.notification.username.split(" ")[0];
    }
    info.group.recentContent = await dispatch(
      "getNotificationContent",
      info.notification
    );
    info.group.hasUnreadPosts =
      info.notification.created_at > info.group.lastVisited;
    info.group.recentTime = timeSincePost;
    info.group.timeOfLastPost = Number(info.notification.created_at);
    info.group.recentUsername = firstName ? firstName + ":" : "";
  },

  getTimeSincePost(_, time) {
    let now = Date.now();
    if (now < time) {
      return "now";
    } else if (time + 3600000 > now) {
      let value = Math.floor((now - time) / 60000);
      if (value < 1) {
        return "now";
      }
      return value + "m";
    } else if (time + 3600000 * 24 > now) {
      return Math.floor((now - time) / 3600000) + "h";
    } else if (time + 3600000 * 24 * 7 > now) {
      return Math.floor((now - time) / (3600000 * 24)) + "d";
    } else if (time + 3600000 * 24 * 30 > now) {
      return Math.floor((now - time) / (3600000 * 24 * 7)) + "w";
    } else {
      return Math.floor((now - time) / (3600000 * 24 * 30)) + "m";
    }
  },

  getNotificationContent(_, notification) {
    if (notification.content == "") {
      let attach =
        notification.files.length == 1 ? "Attachment" : "Attachments";
      return notification.files.length + " " + attach;
    } else {
      return notification.content;
    }
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
